// extracted by mini-css-extract-plugin
export default {"FeedbackForm":"CwpM8oS8","title":"xB7nUHLs","list":"lOvIsHXW","row":"Z_cuAJsr","field":"KlF1BZqp"};
    if(module.hot) {
      // 1776432170707
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  